import _classCallCheck from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/artweek/artweek/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Feature } from '../../motion/features/Feature.mjs';
import { noop } from '../../utils/noop.mjs';
import { VisualElementDragControls } from './VisualElementDragControls.mjs';

var DragGesture = /*#__PURE__*/function (_Feature) {
  _inherits(DragGesture, _Feature);

  var _super = _createSuper(DragGesture);

  function DragGesture(node) {
    var _this;

    _classCallCheck(this, DragGesture);

    _this = _super.call(this, node);
    _this.removeGroupControls = noop;
    _this.removeListeners = noop;
    _this.controls = new VisualElementDragControls(node);
    return _this;
  }

  _createClass(DragGesture, [{
    key: "mount",
    value: function mount() {
      // If we've been provided a DragControls for manual control over the drag gesture,
      // subscribe this component to it on mount.
      var _this$node$getProps = this.node.getProps(),
          dragControls = _this$node$getProps.dragControls;

      if (dragControls) {
        this.removeGroupControls = dragControls.subscribe(this.controls);
      }

      this.removeListeners = this.controls.addListeners() || noop;
    }
  }, {
    key: "unmount",
    value: function unmount() {
      this.removeGroupControls();
      this.removeListeners();
    }
  }]);

  return DragGesture;
}(Feature);

export { DragGesture };